import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { translate } from 'react-i18next';
import Helmet from 'react-helmet';

import Loading from '../Loading';
import * as loginActions from '../../action-creators/login';

class DemoContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loaderText: 'Creating demo account, please wait'
    };
  }

  async componentWillMount() {
    const { createDemoAccount } = this.props;
    try {
      await createDemoAccount();
    } catch (e) {
      console.error(e);
      this.setState({ loaderText: 'Creation failed' });
    }
  }

  render() {
    const { t } = this.props;
    const { loaderText } = this.state;

    return (
      <div>
        <Helmet title={t('acc_demo_title')} meta={[{ name: 'description', content: t('acc_demo_description') }]} />
        <Loading text={loaderText} />
      </div>
    );
  }
}

export default connect(null, dispatch =>
  bindActionCreators(
    {
      createDemoAccount: loginActions.createDemoAccount
    },
    dispatch
  )
)(translate(['ui'])(DemoContainer));



// WEBPACK FOOTER //
// ./components/info/DemoContainer.jsx